import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Col, Row, Card } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Heading5, Icon, SearchInput, ToggleSwitch } from '../../widgets';
import { getUserFarmList, assignFarm } from '../../../actions/users';
import AssignedFarmList from './AssignedFarmList';
import { getOrganizationList } from '../../../actions/organization';
import { searchWord } from '../../../helpers/common';
import { SubNav } from '../../layout/submenu/SubNav';

const AssignFarmModal = props => {
    const { actions, organizationList, farmList, onHide, userId, userInfo } = props;
    const [assignedFarmIds, assignFarm] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [showOrganizationWise, setShowOrganizationWise] = useState(false);

    useEffect(() => {
        if (!userInfo.assignedFarmIds) actions.getUserFarmList(userId);
        else if (userInfo.assignedFarmIds && userInfo.assignedFarmIds.length > 0) {
            assignFarm(userInfo.assignedFarmIds.map(item => item.farm_uuid));
        }
    }, [userInfo.assignedFarmIds]);

    useEffect(() => {
        if (organizationList.length === 0) props.actions.getOrganizationList();
    }, []);

    const handleSave = () => {
        const params = { user_id: userId, farm_uuid: assignedFarmIds };

        const onSuccess = () => {
            setIsSaving(false);
            onHide();
        };

        setIsSaving(true);
        actions.assignFarm(params, onSuccess);
    }

    const handleAssignFarm = (farmId) => assignFarm([...assignedFarmIds, farmId]);

    const handleUnassignFarm = (farmId) => {
        assignedFarmIds.splice(assignedFarmIds.indexOf(farmId), 1);
        assignFarm([...assignedFarmIds])
    };

    const getOrganizationListById = (organizationList) => {
        const listById = {};
        organizationList.forEach(item => { listById[item.organization_uuid] = item; });

        return listById;
    }
    const organizationListById = useMemo(() => getOrganizationListById(organizationList), [organizationList]);

    const getFilteredFarmList = (farmList, searchText) => {
        return farmList.filter(e => (assignedFarmIds.indexOf(e.farm_uuid) < 0 && searchWord(e.name, searchText)));
    }
    let filteredFarmList = useMemo(() => getFilteredFarmList(farmList, searchText), [farmList, assignedFarmIds, searchText]);
    filteredFarmList = filteredFarmList.filter(item => item.status_id === 1);
    const archivedFarmList = farmList.filter(item => item.status_id === 5);

    const getFarmListById = (farmList, assignedFarmIds, searchText) => {
        const filteredFarmList = farmList.filter(item => (assignedFarmIds.indexOf(item.farm_uuid) < 0
            && searchWord(item.organization_name, searchText)));

        const farmListByOrganizationId = filteredFarmList.reduce((objectsByKeyValue, obj) => {
            const value = obj.organization_uuid;
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {});

        return farmListByOrganizationId;
    }
    const farmListByOrganizationId = useMemo(() => getFarmListById(farmList, assignedFarmIds, searchText),
        [farmList, assignedFarmIds, searchText]);

    const handleAssignOrganization = (organizationId) => {
        const farmIds = farmListByOrganizationId[organizationId].map(item => item.farm_uuid)
        assignFarm([...assignedFarmIds, ...farmIds]);
    }

    const isRequesting = userInfo.isRequestingAssignedFarm ? userInfo.isRequestingAssignedFarm : false;

    return <Modal show={true} backdrop="static" onHide={onHide} size='xl' className="assign-farm-modal">
        <Modal.Header closeButton style={{ color: '#064d9e' }}>
            <Modal.Title >
                <Heading5>
                    Assign Farm
                </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <AssignedFarmList isRequesting={isRequesting} userId={userId}
                    assignedFarmIds={assignedFarmIds}
                    handleUnassignFarm={handleUnassignFarm}
                    assignFarm={assignFarm}
                    organizationListById={organizationListById}
                />
                <Col sm={4} md={4} lg={4} className="available-farms">
                    <div className="search-input">
                        <SearchInput className="w-100" onChange={searchText => setSearchText(searchText)} />
                    </div>
                    <div className="toggle-switch">
                        <span className="label">Show Organization List</span>
                        <ToggleSwitch
                            onChange={(e) => {
                                setShowOrganizationWise(e.target.checked);
                                setSearchText("");
                            }}
                            checked={showOrganizationWise}
                            title={showOrganizationWise ? "Show Farm List" : "Show Organization List"}
                        />
                    </div>
                    {showOrganizationWise ?
                        <div className={`m-0 farm-items`}>
                            {Object.keys(farmListByOrganizationId).map(organizationId => <Card key={organizationId} className="farm-item">
                                <div>
                                    <Row className="name m-0">{organizationListById[organizationId].organization_name}</Row>
                                </div>
                                <Button className="btn-success btn-sm add-btn" title={"Assign Farm"}
                                    onClick={() => handleAssignOrganization(organizationId)}>Add</Button>
                            </Card>
                            )}
                        </div>
                        : <div className={`m-0 farm-items`}>
                            {filteredFarmList.map(item => <Card key={item.farm_uuid} className="farm-item">
                                <div>
                                    <Row className="name m-0">{item.name}</Row>
                                    <Row className="sub-name m-0"> {item.organization_name}</Row>
                                </div>
                                <Button className="btn-success btn-sm add-btn" title={"Assign Farm"}
                                    onClick={() => handleAssignFarm(item.farm_uuid)}>Add</Button>
                            </Card>
                            )}
                            {archivedFarmList.length > 0 && <SubNav.Divider name={'Archived'} className='archive' />}
                            {archivedFarmList && archivedFarmList.map(item => <Card key={item.farm_uuid} className="farm-item">
                                <div>
                                    <Row className="name m-0">{item.name}</Row>
                                    <Row className="sub-name m-0"> {item.organization_name}</Row>
                                </div>
                                <Button className="btn-success btn-sm add-btn" title={"Assign Farm"}
                                    onClick={() => handleAssignFarm(item.farm_uuid)}>Add</Button>
                            </Card>
                            )}
                        </div>}
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant='btn btn-danger btn-sm' onClick={onHide} ><i className="fa fa-times-circle"></i> Cancel</Button>
            <Button variant='btn  btn-primary btn-sm' onClick={handleSave} ><Icon className="fa fa-floppy-o"></Icon>{isSaving ? " Saving..." : " Save"}</Button>
        </Modal.Footer>
    </Modal>
};

const mapStateToProps = (state, ownProps) => ({
    farmList: state.users.farmList.payload,
    userInfo: state.users.userListById.payload[ownProps.userId],
    organizationList: state.organization.organizationList
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getUserFarmList, assignFarm, getOrganizationList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignFarmModal);